import React, { ReactNode, useRef, useState } from "react"

import moment from "moment-timezone"

import TimeProtectedModal from "./TimeProtectedModal"

export type TimeProtectedLinkProps = {
  text?: string
  children?: ReactNode
  href: string
  startsAt: string
  method?: string
  strictMode?: boolean
  tailwind?: boolean
  className?: string
}

const TimeProtectedLink: React.FC<TimeProtectedLinkProps> = ({
  children,
  text,
  href,
  startsAt,
  method,
  strictMode = false,
  tailwind = false,
  ...rest
}) => {
  const hiddenLink = useRef<HTMLAnchorElement>()
  const [showModal, setShowModal] = useState(false)
  const [timeString, setTimeString] = useState<string | null>()

  const onClick = () => {
    const timeDiff = moment(startsAt).unix() - moment().unix()
    const timeDiffMinutes = timeDiff / 60

    const accessibleWindow = strictMode ? 2 : 60

    if (timeDiffMinutes <= accessibleWindow) {
      hiddenLink.current.click()
    } else {
      const minutes = Math.floor(timeDiffMinutes % 60)
      const hours = Math.floor(timeDiffMinutes / 60)
      if (hours > 24) {
        const days = Math.floor(hours / 24)
        setTimeString(`${days} ${days === 1 ? "day" : "days"}`)
      } else if (hours > 0) {
        setTimeString(`${hours} hours and ${minutes} minutes`)
      } else {
        setTimeString(`${minutes} minutes`)
      }
      setShowModal(true)
    }
  }

  return (
    <>
      <a
        ref={hiddenLink}
        style={{ display: "none" }}
        href={href}
        data-method={method === "get" ? null : method}
        target="_blank"
        rel="noreferrer noopener"
        {...rest}
      >
        Hidden
      </a>
      <a onClick={onClick} target="_blank" rel="noreferrer noopener" {...rest}>
        {children ? children : text}
      </a>
      <TimeProtectedModal
        isOpen={showModal}
        setOpen={setShowModal}
        timeString={timeString}
        tailwind={tailwind}
        onSubmit={() => hiddenLink.current.click()}
        strictMode={strictMode}
      />
    </>
  )
}

export default TimeProtectedLink
